import { render, staticRenderFns } from "./collection-overview.vue?vue&type=template&id=06098fbe"
import script from "./collection-overview.vue?vue&type=script&lang=ts"
export * from "./collection-overview.vue?vue&type=script&lang=ts"
import style0 from "./collection-overview.vue?vue&type=style&index=0&id=06098fbe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports